module.exports = __webpack_public_path__ + "static/img/acrobatreaderpath.f5e164d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/acrobatreaderpath.png
// module id = rteA
// module chunks = 0